// CheckoutForm.jsx

import React, { useEffect, useState } from "react";
import { CardNumberElement, CardCvcElement, CardExpiryElement, useStripe, useElements } from '@stripe/react-stripe-js';
import UI_Modal from "../../../UiComponents/UI_Modal copy";
import { Button, } from "../../../Components";
import { toast } from "react-toastify";
const mainStyle = {
    // backgroundColor: '#343f4a',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '30px 50px 10px 50px',
    height: 'fit-content',
}
const CheckoutForm = ({
    offerPrice,
    isStripeOpen,
    setisStripeOpen,
    card,
    setCard,
    makePayment,
    setIsSuccessOpen,
    setLoading,
    setIsOpen,
    IsUpgradeOpen,
    getTime,
    setCoupanName,
    setCoupanError,
    setStripeOpen,
    cardDetails,
    openNewTab,
    setRenderOpen
}) => {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    const [error, setError] = useState('');
    const [isDisabled, setIsDisabled] = useState(true)
    const stripe = useStripe();
    const elements = useElements();
  
    const handleChange = (event) => {
        if (event.elementType === "cardNumber" || event.elementType === "cardCvc" || event.elementType === "cardExpiry") {
            const elementType = event.elementType;
            const isComplete = event.complete;

            setCard(prevCard => ({
                ...prevCard,
                [elementType]: isComplete,
            }));
        } else if (event.target) {
            const { name, value } = event.target;

            setCard(prevCard => ({
                ...prevCard,
                [name]: value,
            }));
        }

        setError('');
    };
    const handleSubmit = async () => {
        // event.preventDefault()
        setIsDisabled(false)
      
        const cardElement = elements.getElement(CardNumberElement);
        // const { token, error } = await stripe.createToken(cardElement);

        const { paymentMethod, error: paymentMethodError } = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
        });
        if (paymentMethodError && paymentMethodError.type === "card_error") {
            toast.error("Card Declined");
            setIsDisabled(true)
            return;
        } else {
            if (paymentMethod) {
                const payment_res = await makePayment(paymentMethod)
                if (payment_res.success) {
                    const { client_secret, stripe_status } = payment_res.newRecurring
                    if (stripe_status === 'requires_action') {
                        stripe.confirmCardPayment(client_secret).then(function (result) {
                            if (result.error) {
                                toast.error(result.error.message);
                                setisStripeOpen(false)
                                setLoading(false);
                                setCoupanName('')
                                setCoupanError('')
                                setCard(cardDetails)

                            } else {
                                setLoading(false);
                                toast.success('Subscription is success');
                                setIsSuccessOpen(true);
                                setIsOpen(false);
                                IsUpgradeOpen(false);
                                getTime();
                                setisStripeOpen(false);
                                setCoupanName('');
                                setCoupanError('')
                                setStripeOpen(false);
                                setCard(cardDetails);
                                setRenderOpen(false);
                                openNewTab();
                            }
                        });
                    } else {
                        setLoading(false);
                        toast.success('Subscription is success');
                        setIsSuccessOpen(true)
                        setIsOpen(false)
                        IsUpgradeOpen(false)
                        getTime()
                        setisStripeOpen(false)
                        setCoupanName('')
                        setCoupanError('')
                        setStripeOpen(false)
                        setCard(cardDetails)
                        setRenderOpen(false);
                        openNewTab()
                    }
                }
                setIsDisabled(true)
            } else {
                if (error.code === "incomplete_number" || error.code === "invalid_number") setError('Invalid Card Number')
            }
        }

        setIsDisabled(true)
    };
    const handleClose = () => {
        setisStripeOpen(false);
        setCard(cardDetails)
    }

    return (
        <>
            <UI_Modal
                isOpen={isStripeOpen}
                closeModal={handleClose}
                title={'Payment Details'}
            >
                <div className=" h-full text-[#fff]">
                    {offerPrice}
                    <form autocomplete="on">
                        <div style={mainStyle}>
                            <div className="w-full h-full pb-4">
                                <label className="checkout_form_label">Enter the 16-digit number on the card</label>
                                <CardNumberElement
                                    type="number"
                                    className="border-[1px] rounded "
                                    onChange={(e) => handleChange(e)}
                                    options={{
                                        style: {
                                            base: {
                                                lineHeight: '32px',
                                                // fontFamily: "Avenir Regular",
                                                fontWeight: 500,
                                                fontSize: '1.5rem',
                                                // lineHeight: '1.75rem',
                                                borderRadius: '20px',
                                                '::placeholder': {
                                                    color: 'gray',
                                                    paddingLeft: '10px ',

                                                },
                                                color: 'black',
                                                backgroundColor: '#e7e6e4',
                                            },
                                        },
                                    }}
                                />
                                {error && <span>{error}</span>}
                            </div>
                            <div className="pb-4 " style={{ display: 'flex', }}>
                                <div className="" style={{ width: '150px' }}>
                                    <label className="checkout_form_label">Expiry</label>
                                    <CardExpiryElement
                                        type="expiry"
                                        onChange={(e) => handleChange(e)}
                                        className="border-[1px] rounded "
                                        options={{
                                            style: {
                                                base: {
                                                    lineHeight: '32px',
                                                    // fontFamily: "Avenir Regular",
                                                    fontWeight: 500,
                                                    fontSize: '1.5rem',
                                                    '::placeholder': {
                                                        color: 'gray',
                                                    },
                                                    color: 'black',
                                                    backgroundColor: '#e7e6e4',
                                                },
                                            },
                                        }}
                                    />
                                </div>
                                <div className="ml-[50px]" style={{ width: '150px' }}>
                                    <label className="checkout_form_label tracking-widest" >CVV</label>
                                    <CardCvcElement
                                        type="cvv"
                                        onChange={(e) => handleChange(e)}
                                        className="border-[1px] rounded "
                                        options={{
                                            style: {
                                                base: {
                                                    lineHeight: '32px',
                                                    // fontFamily: "Avenir Regular",
                                                    fontWeight: 500,
                                                    fontSize: '1.5rem',

                                                    '::placeholder': {
                                                        color: 'gray',
                                                    },
                                                    color: 'black',
                                                    backgroundColor: '#e7e6e4',

                                                },
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="pb-4">
                                <label className="checkout_form_label">Zipcode</label>
                                <input className="border-[1px] rounded pl-2 text-xl"
                                    style={{ backgroundColor: '#e7e6e4', width: '100%', height: '32px', color: 'black' }}
                                    type="text"
                                    name="zipcode"
                                    value={card?.zipcode}
                                    onChange={(e) => handleChange(e)}
                                />
                            </div>
                            <div className="pb-4" >
                                <label className="checkout_form_label">Email for receipt</label>
                                <input className="border-[1px] rounded pl-2 text-xl"
                                    style={{ backgroundColor: 'gray', width: '100%', height: '32px', color: 'black' }}
                                    type="email"
                                    name="email"
                                    value={card?.email}
                                    // value={userInfo?.email}
                                    onChange={(e) => handleChange(e)}
                                />
                            </div>

                            <div className="" style={{ textAlign: 'center', margin: '1rem auto' }}>
                                <Button
                                    type="button"
                                    buttonStyle="btn--solid"
                                    buttonSize="btn--size"
                                    onClick={handleSubmit}
                                    disabled={!card?.zipcode || !card?.email || !card?.cardNumber || !card?.cardExpiry || !card?.cardCvc }
                                >
                                    Upgrade Now
                                </Button>
                            </div>
                            {!isDisabled &&
                                <div className="" style={{ textAlign: 'center', margin: '1rem auto' }}>
                                    <span style={{ color: '#fff' }}>processing...</span>
                                </div>
                            }
                        </div>
                    </form>
                </div>
            </UI_Modal>

        </>
    );
};

export default CheckoutForm;

